import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '../shared/api/baseApi';
import { sessionReducer } from '../entities/session/model/slice';
import { organizationReducer } from '../entities/organization/model/slice';
import './apiRegistry';

export const store = configureStore({
  reducer: {
    session: sessionReducer,
    organization: organizationReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
